import { render, staticRenderFns } from "./BoxArt2D.vue?vue&type=template&id=6499881a&scoped=true&"
import script from "./BoxArt2D.vue?vue&type=script&lang=js&"
export * from "./BoxArt2D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6499881a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\Node\\megadrive\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6499881a')) {
      api.createRecord('6499881a', component.options)
    } else {
      api.reload('6499881a', component.options)
    }
    module.hot.accept("./BoxArt2D.vue?vue&type=template&id=6499881a&scoped=true&", function () {
      api.rerender('6499881a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BoxArt2D.vue"
export default component.exports